export default function() {
  return data;
}
let data = {
  zoneOne: { top: "42.5%", left: "1%" },
  zoneTwo: { top: "30.7%", left: "6.57%" },
  zoneThree: { top: "30.7%", left: "18.24%" },
  zoneFour: { top: "44.5%", left: "33.65%" },
  zoneFive: { top: "30.75%", left: "44.23%" },
  zoneSix: { top: "36.55%", left: "57.55%" },
  zoneSeven: { top: "43.9%", left: "86.5%" },
  zoneEight: { top: "31%", left: "22.45%" },
  zoneNine: { top: "27.93%", left: "46.699%" },
  zoneTen: { top: "28.8%", left: "55.9%" },
  zoneEleven: { top: "31.35%", left: "8.55%" },
  zoneTwelve: { top: "31.4%", left: "65.54%" }
};
